<template>
  <div>
    <div class="pdp-quantity-and-size aside-sticky-button-width">
      <!-- sample size -->
      <input
        disabled
        class="form-control text-uppercase mb-2"
        type="text"
        v-if="
          selectedColor &&
            selectedColor.samples &&
            selectedColor.samples.length
            && Number(selectedColor.samples[0].vehicleId) === 0
        "
        :value="getFirstSize"
      />

      <!-- Custom Dropdown -->
      <div class="pdp-sample-size-options mt-3 mt-xl-0 mb-3 bg-white position-relative" v-else>
        <button
          class="btn dropdown-toggle px-1 text-transform-none aside-sticky-button-width"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          :disabled="
          !(
            selectedColor &&
            selectedColor.samples &&
            selectedColor.samples.length
          ) || selectedColor &&
            selectedColor.samples &&
            selectedColor.samples.length === 1
        "
        >
          <p class="m-0 px-2 option-display">
            {{ getSelectedOption }}
          </p>
          <span class="png-icon png-icon-icons-glyph--g-chevron-down"></span>
        </button>

        <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton" v-if="selectedColor &&
            selectedColor.samples &&
            selectedColor.samples.length">
          <div
            class="option"
            v-if="!selectedColor.samples.length || !vehicleId"
            @click="selectOption('')"
          >
            <span>{{ $resourceString["pdp.AsideBottom.Placeholder.SampleSize"] }}</span>
          </div>
          <div
            class="option"
            v-for="(sample, index) in selectedColor.samples"
            :key="sample.vehicleId"
            @click="selectOption(sample)"
            v-if="getSelectedOption !== (sample.sizes[0].imperialDisplayValue + ' - ' + checkSampleType(sample.vehicleId))"
          >
            <span>
              {{ sample.sizes[0].imperialDisplayValue }} - {{ checkSampleType(sample.vehicleId) }}
            </span>

            <hr v-if="selectedColor.samples.length > 2 &&
              index !== selectedColor.samples.length - 1 &&
              getSelectedOption !== (sample.sizes[0].imperialDisplayValue + ' - ' + checkSampleType(sample.vehicleId))">

          </div>
        </div>

      </div>
      <div class="quantity-container input-group-container" v-if="!isPDP">
        <!-- quantity -->
        <div class="quantity-input-group input-group">
          <label
            for="quantity"
            class="quantity-label description text-uppercase"
          >
            {{ $resourceString["pdp.aside.bottom.quantity"] }}</label
          >
          &nbsp;

          <div
            class="input-group-prepend bg-white border-1 minus"
            @click="onMinusClick"
            :disabled="quantity <= 1"
          >
            -
          </div>
          <input
            name="quantity"
            v-model.number="quantity"
            min="1"
            :max="getMaxQuantity"
            class="quantity-input"
            @change="onQuantityChange($event)"
            :disabled="
              !(
                (selectedColor &&
                  selectedColor.samples &&
                  selectedColor.samples.length) ||
                (selectedColor && selectedColor.samples.length)
              )
            "
          />
          <div
            class="input-group-append bg-white border-1 plus"
            @click="onPlusClick"
            :disabled="quantity >= getMaxQuantity"
          >
            +
          </div>
        </div>

        <div
          class="unqiue-quantity-container"
          v-if="this.trustedUserFlag != 'true'"
        >
          <span class="unique-quantity-notice">
            {{ $resourceString["pdp.aside.bottom.unique.quantity"] }}</span
          >
        </div>
      </div>
    </div>

    <!-- add to cart button -->
    <button
      type="button"
      :class="'wf-add-to-cart-button aside-sticky-button-width ' + cssClasses"
      @click="addItemToCart"
      :disabled="
        (
          selectedColor &&
          selectedColor.samples &&
          selectedColor.samples.length
          && Number(selectedColor.samples[0].vehicleId) === 0
        ) || OrderSampleEnabled
            || samplesAvailable === 0
      "
    >
      <slot>
        <span :class="'png-icon png-icon-' + iconName"> </span>
        <span class="ml-2"> {{ buttonText }} </span>
      </slot>
    </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      vehicleId: "",
      quantity: 1
    };
  },
  props: {
    sellingStyleNumber: {
      type: String,
      required: true
    },
    colorNumber: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "Add sample to basket"
    },
    cssClasses: {
      type: String,
      default: "btn btn-primary"
    },
    iconName: {
      type: String,
      default: "icons-glyph--ko-my-basket"
    },
    productIndex: 0,
    trustedUserFlag: {
      default: false
    },
    isPDP:{
      type:Boolean
    }
  },
  created() {
    if (this.selectedColor && this.selectedColor.samples) {
      this.vehicleId = this.selectedColor.samples[0]?.vehicleId;
      this.setImperialDisplayValue(this.selectedColor?.samples[0]?.sizes[0]?.imperialDisplayValue);
    }
    this.isOrderSampleEnabled();
    this.$store.dispatch("basketPage/fetchFullTypeSizeSamples");
  },
  watch: {
    selectedColor() {
      this.vehicleId = this.selectedColor?.samples[0]?.vehicleId;
      this.quantity = 1;
    }
  },
  computed: {
    ...mapGetters({
      selectedColor: "productDetail/color",
      trustedUser: "productDetail/getTrustedUser",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
      getFullTypeSizeSamples: "basketPage/getFullTypeSizeSamples",
      samplesAvailable: "productDetail/samplesAvailable"
    }),
    getMaxQuantity() {
      let inStockQty = 10; //Default
      let mapStock = 0;
      if (this.trustedUser && this.trustedUser?.QuantityInStock) {
        mapStock = new Map(Object.entries(this.trustedUser.QuantityInStock));
        mapStock = mapStock.get(this.vehicleId);
      }
      if (this.trustedUserFlag) {
        inStockQty = mapStock;
      } else if (mapStock < inStockQty) {
        inStockQty = mapStock;
      }
      return inStockQty;
    },
    getFirstSize() {
      return this.selectedColor?.samples[0]?.sizes.length > 0
        ? this.selectedColor?.samples[0]?.sizes[0]?.imperialDisplayValue
        : this.$resourceString["pdp.aside.bottom.smaplesize.notavailable"];
    },
    getSelectedOption() {
      const selectedSample = this.selectedColor.samples?.find(sample => sample.vehicleId === this.vehicleId);
      if (selectedSample) {
        const size = selectedSample?.sizes[0]?.imperialDisplayValue;
        const type = this.checkSampleType(selectedSample.vehicleId);
        return `${size} - ${type}`;
      }
      return this.$resourceString["pdp.AsideBottom.Placeholder.SampleSize"];
    },
  },
  methods: {
    ...mapActions({
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
      addToCart: "basketPage/addToCart",
      setImperialDisplayValue: "productDetail/setImperialDisplayValue",
      setVehicleId: "productDetail/setVehicleId",
      setAvailableSamples: "productDetail/setAvailableSamples"
    }),

    checkSampleType(vehicleIdValue) {
      let isFullSize = this.getFullTypeSizeSamples?.find(
        ({ Key, Value }) => Key === vehicleIdValue && Value === true
        );
      if (isFullSize) {
        return "Full Sample";
      } else {
        return "Cut Sample";
      }
    },
    addItemToCart() {
      let data = {
        sellingStyleNumber: this.sellingStyleNumber,
        colorNumber: this.colorNumber,
        vehicleId: this.vehicleId
          ? this.vehicleId
          : this.selectedColor.samples.length
          ? this.selectedColor.samples[0].vehicleId
          : "",
        quantity: this.quantity,
        saveForLater: false
      };
      this.addToCart(data);
    },
    selectOption(sample) {
      this.vehicleId = sample?.vehicleId;
      this.setImperialDisplayValue(sample?.sizes[0]?.imperialDisplayValue);
      this.setVehicleId(this.vehicleId);
      this.setAvailableSamples();
    },

    onMinusClick() {
      if (this.quantity > 1) {
        this.quantity -= 1;
      }
    },
    onPlusClick() {
      if (this.quantity < this.getMaxQuantity) {
        this.quantity += 1;
      }
    },
    onQuantityChange() {
      if (this.quantity > this.getMaxQuantity) {
        this.quantity = this.getMaxQuantity;
      } else if (this.quantity < 1) {
        this.quantity = 1;
      }
    }
  }
};
</script>
